export const environment = {
  production: true,
  ignoreValidators: false,
  disableCopy: false,
  apiMode: 'gateway',// apiMode: 'gateway' | 'soa' | 'siebel'
  api_gateway: 'https://api.dubaichamber.com/v1/',
  api_siebel: 'https://dcdevcrm.dubaichamber.com:9443/siebel/v1.0/service/Workflow%20Process%20Manager%20REST/',
  api_soa_dev: 'https://dcsoafmwdev.dubaichamber.com/',
  api_soa_sit: 'https://dcsoafmwsit.dubaichamber.com/',
  venueImageHostUrl: 'https://venues.dubaichamber.com',
  wso2URL: 'https://dcdigitalservicessso.dubaichamber.com',
  wso2APIURL: 'https://api.dubaichamber.com/wso2/',
  clientId: 'li6Geeois_CgKoJHbfwQRrOvLxIa',
  scopes: 'openid profile email internal_login',
  responseType: 'code',
  wso2LogoutURL: 'https://dcdigitalservicessso.dubaichamber.com/oidc/logout',
  changePasswordURL: 'https://dcdigitalservicessso.dubaichamber.com/accountrecoveryendpoint/recoveraccountrouter.do?client_id=li6Geeois_CgKoJHbfwQRrOvLxIa&code_challenge=ZaBUNTsmZop2IHdjrj170tBZ6r-dkxu1kEw4WV8alZQ&code_challenge_method=S256&commonAuthCallerPath=%2Foauth2%2Fauthorize&forceAuth=false&passiveAuth=false&redirect_uri=https%3A%2F%2Fconnect.dubaichamber.com%2Flogin-callback&response_type=code&scope=openid+internal_login&state=test123&sessionDataKey=9b8eefc8-10cb-44a8-b55e-0908aa789307&relyingParty=li6Geeois_CgKoJHbfwQRrOvLxIa&type=oidc&sp=DCC-COMMUNITY&spId=1be724f8-72df-44e7-83cc-5909b3a6237f&isSaaSApp=false&authenticators=OpenIDConnectAuthenticator%3AUAE+PASS%3BBasicAuthenticator%3ALOCAL&isUsernameRecovery=false&callback=https%3A%2F%2Fconnect.dubaichamber.com%2F',
  servicesHappinessURL: 'https://happinessmeter.dubaichamber.com',
  businessGroupPlatformUrl: 'https://dcdigitalcrm.dubaichamber.com/siebel/app/pseservicesso/enu',
  documentEncryption: true,
  guestTokenUrl: 'https://api.dubaichamber.com/wso2/v1/oauth2/token',
  guestTokenScope: 'openid address email profile',
  guestUser:"GUESTCST",
  enableHappinessMeter: true,
  mVP1Settings: {
    faqDropDownEnabled: true,
    chatEnabled: true,
    bgcEnabled: true,
    sustainabilityEnabled: false,
    accountManagementEnabled: true,
    ataEnabled: true,
    mediationEnabled: true,
    documentsEnabled: true,
    venueEnabled: true,
    directoryEnabled: true,
    searchEnabled: true,
    notificationsSettingsEnabled: true,
    showFavouriteButton: true,
    enableDashboardAlert: false,
  },
};
